import {
  Box,
  Container,
  IconButton,
  Modal,
  Pagination,
  Typography,
} from "@mui/material";
// import { BottomPage } from "components/BottomPagination";
// import InspStatusModal from "components/modal/InspStatusModal";
import InspStatusTable from "../components/inspStatus/InspStatusTable.js";
import { CloseIcon } from "../icons/index.tsx";
import { useEffect, useState } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  inspStatusFilterState,
  selectedButtonState,
  selectedMenuState,
} from "../recoil/index.ts";
import { getLatestData } from "../services/inspectStatReportService.js";
import InspStatusModal from "../components/inspStatus/InspStatusModal.js";

export default function InspStatusPage({
  isFilterReset,
  setIsFilterReset,
  queryOption,
  setQueryOption,
}) {
  const setSelectedMenu = useSetRecoilState(selectedMenuState);
  const setSelectedButton = useSetRecoilState(selectedButtonState);
  const [openModal, setOpenModal] = useState(false);
  const [uuid, setUuid] = useState(null);
  const [tableDataByPage, setTableDataByPage] = useState([]);
  const [count, setCount] = useState(1);
  const [receivedData, setReceivedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterOption, setFilterOption] = useRecoilState(inspStatusFilterState);
  const [pageData, setPageData] = useState(null);

  useEffect(() => {
    setSelectedMenu("검사현황");
    setSelectedButton("검사현황");
  }, []);

  useEffect(() => {
    const fetchLatestData = async () => {
      const response = await getLatestData();
      if (response && response.latestRecord) {
        const latestDate = response.latestRecord.create_at.split("T")[0];
        setFilterOption((prev) => ({
          ...prev,
          start_date: latestDate,
          end_date: latestDate,
        }));
      }
    };
    fetchLatestData();
  }, []);

  const changePage = (page) => {
    setQueryOption((prev) => ({ ...prev, page: page }));
  };

  return (
    <>
      <InspStatusTable
        setOpenModal={setOpenModal}
        setUuid={setUuid}
        uuid={uuid}
        setTableData={setTableDataByPage}
        receivedData={receivedData}
        setReceivedData={setReceivedData}
        setCount={setCount}
        setPageData={setPageData}
        setCurrentPage={setCurrentPage}
        isFilterReset={isFilterReset}
        setIsFilterReset={setIsFilterReset}
        queryOption={queryOption}
        setQueryOption={setQueryOption}
      />

      <Pagination
        count={Math.ceil(count / queryOption.pageSize)}
        page={queryOption.page}
        onChange={(_, value) => {
          changePage(value);
        }}
        color="primary"
        size="medium"
        sx={{ mt: 2, display: "flex", justifyContent: "center" }}
      />
      {openModal && (
        <Modal open={openModal} onClose={() => setOpenModal(false)}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              borderRadius: "8px",
              boxShadow: 24,
              width: "90%",
              maxWidth: "700px",
              minWidth: "600px",
              // maxHeight: "700px",
              // height: "700px",
              display: "flex",
              flexDirection: "column",
              overflowY: "auto",
              outline: "none",
              bgcolor: "white",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                p: "10px 24px",
                borderBottom: "1px solid #ddd",
              }}
            >
              <Typography
                variant="h6"
                component="h2"
                sx={{
                  fontWeight: 700,
                  color: "var(--text-color)",
                }}
                fontFamily={"NotoSansKR-Variable"}
              >
                View Inspection Status
              </Typography>
              <IconButton onClick={() => setOpenModal(false)}>
                <CloseIcon />
              </IconButton>
            </Box>
            <InspStatusModal
              uuid={uuid}
              setUuid={setUuid}
              tableData={tableDataByPage}
              setOpenModal={setOpenModal}
              totalCount={count}
              pageData={pageData}
            />
          </Box>
        </Modal>
      )}
    </>
  );
}
